import { render, staticRenderFns } from "./ENotificacoesList.vue?vue&type=template&id=31fae987&scoped=true"
import script from "./ENotificacoesList.vue?vue&type=script&lang=js"
export * from "./ENotificacoesList.vue?vue&type=script&lang=js"
import style0 from "./ENotificacoesList.vue?vue&type=style&index=0&id=31fae987&prod&scoped=true&lang=css"
import style1 from "./ENotificacoesList.vue?vue&type=style&index=1&id=31fae987&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fae987",
  null
  
)

export default component.exports